<template>
  <div>
    <b-tooltip :type="tooltipType">
      <span
        class="icon"
        :class="textClass"
        :style="{ cursor: reward && reward.tournament ? 'pointer' : 'default' }"
        @click="handleClick"
      >
        <i class="fa-lg" :class="iconClass" />
      </span>
      <template v-slot:content>
        <p>{{ eventText }}</p>
        <i>{{ trophyText }}</i>
        <div v-if="reward && reward.player && reward.tournament">
          <RoundResults
            :roundsParticipated="reward.player.roundsParticipated"
            :currentRoundNumber="reward.tournament.currentRound"
            :totalRounds="reward.tournament.totalRounds"
            :username="reward.player.username"
            :games="reward.player.games"
          />
        </div>
      </template>
    </b-tooltip>
  </div>
</template>

<script>
import RoundResults from "@/components/tournaments/RoundResults.vue";
import { REWARD } from "../../constants";

export default {
  components: { RoundResults },
  name: "Trophy",

  props: ["reward", "text"],

  computed: {
    rewardText() {
      if (this.text) return this.text;
      if (this.reward) return this.reward.player.reward;
      return null;
    },

    type() {
      if (!this.rewardText) return null;
      return this.rewardText.split("|")[0];
    },

    rank() {
      if (!this.rewardText) return null;
      const s = this.rewardText.split("|");
      if (s.length > 1) return s[1];
      return null;
    },

    eventText() {
      if (!this.reward) return null;
      if (this.reward.type === "tournament") {
        return this.reward.tournament.name;
      }
      return null;
    },

    trophyText() {
      let s = "Participation";
      if (this.rank) s = `Rank #${this.rank}`;
      if (this.reward && this.reward.type === "tournament") {
        s += ` - Score: ${this.reward.player.score}`;
      }
      return s;
    },

    iconClass() {
      switch (this.type) {
        case REWARD.TROPHY:
          return "fas fa-trophy";
        case REWARD.MEDAL:
          return "fas fa-medal";
        case REWARD.PARTICIPATION:
          return "fas fa-award";
        default:
          return "";
      }
    },

    textClass() {
      if (this.rank == 1) return "gold";
      if (this.rank == 2) return "silver";
      if (this.rank == 3) return "bronze";
      return "metal";
    },

    tooltipType() {
      return "is-primary";
    },
  },

  methods: {
    handleClick() {
      if (this.reward && this.reward.tournament) {
        this.$router.push(`/tournaments/${this.reward.tournament.id}`);
      }
    },
  },
};
</script>

<style scoped>
.gold {
  color: #af9500 !important;
}

.silver {
  color: #b4b4b4 !important;
}

.bronze {
  color: #6a3805 !important;
}

.metal {
  color: #0066cc !important;
}
</style>
